// Cho phép nhập các kí tự:
// * a-z A-Z 0-9  
// * Hai kí tự đặc biệt gạch nối (-), dấu chấm (.) và xếp gạch (_)
export const preventSpecialCharacterRegex = /^[a-zA-Z0-9-_.]+$/i;